/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_Format_SettingsInputs */

const en_auto_format_settings = /** @type {(inputs: Auto_Format_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto format settings`)
};

const fr_auto_format_settings = /** @type {(inputs: Auto_Format_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres d’auto-formatage`)
};

const de_auto_format_settings = /** @type {(inputs: Auto_Format_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen für automatische Formatierung`)
};

const it_auto_format_settings = /** @type {(inputs: Auto_Format_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni di formattazione automatica`)
};

const ru_auto_format_settings = /** @type {(inputs: Auto_Format_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки автоматического форматирования`)
};

const es_auto_format_settings = /** @type {(inputs: Auto_Format_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración de formato automático`)
};

const zh_cn2_auto_format_settings = /** @type {(inputs: Auto_Format_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动格式设置`)
};

const ja_auto_format_settings = /** @type {(inputs: Auto_Format_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動フォーマット設定`)
};

const hi_auto_format_settings = /** @type {(inputs: Auto_Format_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑटो फॉर्मेट सेटिंग्स`)
};

const pt_pt2_auto_format_settings = /** @type {(inputs: Auto_Format_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações de formatação automática`)
};

/**
* | output |
* | --- |
* | "Auto format settings" |
*
* @param {Auto_Format_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_format_settings = /** @type {((inputs?: Auto_Format_SettingsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_Format_SettingsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_auto_format_settings(inputs)
	if (locale === "de") return de_auto_format_settings(inputs)
	if (locale === "it") return it_auto_format_settings(inputs)
	if (locale === "ru") return ru_auto_format_settings(inputs)
	if (locale === "es") return es_auto_format_settings(inputs)
	if (locale === "zh-CN") return zh_cn2_auto_format_settings(inputs)
	if (locale === "ja") return ja_auto_format_settings(inputs)
	if (locale === "hi") return hi_auto_format_settings(inputs)
	if (locale === "pt-PT") return pt_pt2_auto_format_settings(inputs)
	return en_auto_format_settings(inputs)
});